import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';

const Information = ({ number, question, type, title, inputChange, currentValue }) => {
  const handleInputChange = (e) => {
    // Handle input change
    const name = e.target.name;
    let value;
    if(e.target.type === "number"){
      value = parseInt(e.target.value);
    } else {
      value = e.target.value;
    }
    inputChange(name, value);
  };

  return (
    <div>
      <div>
            
          <label className="form-label">
            
          <FormControl fullWidth>
            {type === "select" && (
              <div>
                <InputLabel id="demo-simple-select-label">* {question}</InputLabel>
                
                <Input>
                  <Select
                    label={question}
                    type={"text"}
                    name={title}
                    value={currentValue}
                    onChange={handleInputChange}
                    variant={'filled'}
                    size={'small'}
                  >
                  <MenuItem value={"Male"}>Male</MenuItem>
                  <MenuItem value={"Female"}>Female</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                  </Select>
                </Input>
              </div>
            )}
            
            {number === 7 && (
              <InputLabel id="demo-simple-select-label">{question}</InputLabel>
            )}
            {number !== 7 && type!== 'select' && (
              <InputLabel id="demo-simple-select-label">* {question}</InputLabel>
            )}
            {type === "text" && (
              <Input
                label={question}
                type={type}
                name={title}
                value={currentValue}
                onChange={handleInputChange}
                variant={'filled'}
                color={'primary'}
                size={'small'}
              />
            )}
            
            </FormControl>
            {number === 7 && (
              <div>
                <p><a href="https://www.16personalities.com/" target="_blank" rel="noreferrer">Take 10 minute free MBTI test</a></p>
              </div>
            )}
          </label>
      </div>
    </div>
  );
};

export default Information;
